"use client";

import HubspotForm from "react-hubspot-form";
import {Box, HStack, Icon, Stack, StackProps, Strong, Text} from "@chakra-ui/react";
import {Container} from "../../../components/Container";
import Heading from "../../../components/Heading";
import {CheckIcon} from "@heroicons/react/20/solid";

const SubFeature = ({children}: StackProps) => (
  <HStack minW="40%" flex={1} gap={2} align="flex-start">
    <Icon bg="green.600" rounded="full" color="green.100" p="1px" mt={1} asChild size="sm">
      <CheckIcon />
    </Icon>
    <Text color="gray.100">{children}</Text>
  </HStack>
);

const SignupView = () => (
  <Box
    as="section"
    id="book-a-demo"
    py={[12, 20]}
    bg="gray.900"
    bgGradient="grayBrand"
    borderY="1px solid black"
    scrollMarginTop={["63px", "63px", "63px", "77px"]}
  >
    <Container maxW="6xl" color="white">
      <HStack gap={[6, 12]} align={["stretch", "stretch", "flex-start"]} flexDirection={["column", "column", "row"]}>
        <Stack flex={1} gap={8} bg="white" p={[4, 8]} rounded="lg">
          <Heading color="pink.600">Book a demo</Heading>
          <HubspotForm portalId="143180593" formId="25fe500f-bc64-476f-b67e-5e4e387ffa64" region="eu1" />
        </Stack>

        <Stack flex={1} fontSize="md" py={[4, 8]} gap={4}>
          <Heading size="3xl">
            Win More Deals. Reduce Admin.{" "}
            <Text as="span" color="pink.400" whiteSpace="nowrap">
              Respond Instantly.
            </Text>
          </Heading>

          <Text>
            Turn RFPs and due diligence from a bottleneck into a competitive advantage with Platformed’s RFP and DDQ
            response software.
          </Text>
          <Text>Platformed eliminates the manual work of responding to RFPs, DDQs, and security questionnaires.</Text>
          <Stack gap={2}>
            <SubFeature>
              <Strong>Automated responses to questionnaires</Strong> - Your team can focus on closing deals, not chasing
              down answers
            </SubFeature>
            <SubFeature>
              <Strong>AI-powered, self-maintaining knowledge base</Strong> - Giving your team the power of consistent,
              high quality responses in a fifth of the time
            </SubFeature>
            <SubFeature>
              <Strong>Multi-format support</Strong> - Import and export responses in any format. Platformed can handle
              spreadsheets, portals, PDFs, Word, and more
            </SubFeature>
          </Stack>
          <Text>Say goodbye to arduous, manual tasks - test our AI with your own data in a free trial.</Text>
        </Stack>
      </HStack>
    </Container>
  </Box>
);
export default SignupView;
